module.exports = __webpack_public_path__ + "static/img/environmental-management1.b4f31b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/environmental-management1.jpg
// module id = lrK8
// module chunks = 0